import type {
  ActivityAutopilotEstimateRequest,
  ActivityAutopilotEstimateResponse,
  ActivityAutopilotSuggestRequest,
  ActivityAutopilotSuggestResponse,
} from '../types/activity-autopilot';

import { createApiClient } from '@/lib/api-client';

export async function suggestActivityAutopilot(
  getToken: () => Promise<string | null>,
  organizationId: string,
  data: ActivityAutopilotSuggestRequest
): Promise<ActivityAutopilotSuggestResponse> {
  const apiClient = createApiClient({ getAuthToken: getToken });
  return apiClient.post<ActivityAutopilotSuggestResponse>(
    `/organizations/${organizationId}/ghg/activity-autopilot/suggest`,
    data
  );
}

export async function estimateActivityAutopilot(
  getToken: () => Promise<string | null>,
  organizationId: string,
  data: ActivityAutopilotEstimateRequest
): Promise<ActivityAutopilotEstimateResponse> {
  const apiClient = createApiClient({ getAuthToken: getToken });
  return apiClient.post<ActivityAutopilotEstimateResponse>(
    `/organizations/${organizationId}/ghg/activity-autopilot/estimate`,
    data
  );
}
